/**
 * Performs a case-insensitive substring search on client name and version yielding:
 * 1. The client name and its client versions if the client name matches the search term
 * 2. The client version and its client name if the client version matches the search term
 */
export const searchClientNameAndVersion = ({
  clients,
  searchTerm,
}: {
  clients: Record<string, Array<string>>;
  searchTerm: string;
}) => {
  if (!searchTerm) {
    return clients;
  }

  const searchTermLowerCase = searchTerm.toLocaleLowerCase();

  return Object.entries(clients).reduce(
    (acc, [clientName, clientVersions]) => {
      if (clientName.toLowerCase().indexOf(searchTermLowerCase) > -1) {
        acc[clientName] = clientVersions;
      } else {
        const matchingClientVersions = clientVersions.filter(
          (clientVersion) =>
            clientVersion.toLowerCase().indexOf(searchTermLowerCase) > -1,
        );

        if (matchingClientVersions.length > 0) {
          acc[clientName] = matchingClientVersions;
        }
      }
      return acc;
    },
    {} as Record<string, Array<string>>,
  );
};
